import type { WidgetDefinition } from '../WidgetDefinition';
import { faBriefcaseArrowRight } from '@fortawesome/pro-regular-svg-icons/faBriefcaseArrowRight';
import type { TradeProWidgetModel } from '@thinkalpha/ui-types/contracts/workspace';
import { parseInstrument } from 'src/lib/instrumentUtils';

class TradeProWidgetDefinition implements WidgetDefinition<TradeProWidgetModel, TradeProWidgetModel> {
    type = 'trade-pro' as const;
    nameKey = 'widgets::trade-pro::name' as const;
    roles = ['widgets::trade-pro', 'widgets::order-entry'];
    icon = faBriefcaseArrowRight;
    category = 'widgets::categories::trading' as const;
    defaultDimensions = { h: 0.44, w: 0.4, x: 0.3, y: 0.28 };

    /**
     * Converts a TradePro widget from contract model to view model
     */
    toViewModel(widget: TradeProWidgetModel): TradeProWidgetModel {
        const type =
            widget.type === 'trade-pro'
                ? 'trade-pro'
                : widget.type === 'trade-pro-multi'
                  ? 'trade-pro-multi'
                  : 'trade-pro';
        return {
            ...widget,
            type,
        };
    }

    /**
     * Converts a TradePro widget from view model to contract model
     */
    toContractModel(widget: TradeProWidgetModel): TradeProWidgetModel {
        if (widget.type === 'trade-pro-multi') {
            return {
                ...widget,
                instrument: widget.instrument ?? parseInstrument(widget.symbol ?? ''),
                type: 'trade-pro-multi',
            };
        }

        return {
            ...widget,
            instrument: widget.instrument ?? parseInstrument(widget.symbol ?? ''),
            type: 'trade-pro',
        };
    }
}

export const tradeProWidgetDefinition = new TradeProWidgetDefinition();
